<template>
  <div>
    <div class="custclue-container" v-if="customer">
      <div class="card b-g-w">
        <div class="title">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-invoice"></use>
          </svg>
          <span>{{customer.custName}}</span>
        </div>
        <div class="section van-hairline--top">
          <div class="flex-mb8">
            <span class="key">发票标题：</span>
            <span class="value">{{ customer.invoiceTitle }}</span>
          </div>
          <div class="flex-mb8">
            <span class="key">发票编号：</span>
            <span class="value">{{ customer.invoiceNum }}</span>
          </div>
          <div class="flex-mb8">
            <span class="key">纳税人识别号：</span>
            <span class="value">{{ customer.taxNum }}</span>
          </div>
          <div class="flex-mb8">
            <div class="flex-1">
              <span class="key">账号：</span>
              <span class="value">{{customer.accountNum}}</span>
            </div>
            <div class="flex-1">
              <span class="key">邮编：</span>
              <span class="value">{{customer.postalCode}}</span>
            </div>
          </div>
          <div class="flex-mb8">
            <div class="flex-1">
              <span class="key">发票类型：</span>
              <span class="value">{{invoiceTypeFormat2(customer.invoiceType)}}</span>
            </div>
            <div class="flex-1">
              <span class="key">发票状态：</span>
              <span class="value">{{invoiceStatusFormat2(customer.invoiceStatus)}}</span>
            </div>
          </div>
          <div class="flex-mb8">
            <div class="flex-1">
              <span class="key">邮箱：</span>
              <span class="value">{{customer.email}}</span>
            </div>
            <div class="flex-1">
              <span class="key">电话：</span>
              <span class="value">{{customer.mobile}}</span>
            </div>
          </div>
        </div>
      </div>

      <van-popup v-model="picker.visible" position="bottom">
        <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
      </van-popup>

    </div>
  </div>
</template>

<script>

import { List, Cell, Button, Tag, Dialog, Area, Toast, Icon, Field, Col, Row, CellGroup, Popup, Picker, Radio, RadioGroup, Grid, GridItem, Tab, Tabs, Form, Calendar } from 'vant'
import { listInvoice, getInvoice, delInvoice, addInvoice, updateInvoice, exportInvoice } from "@/api/fina/invoice";
import { getProvinceCityList } from "@/api/system/area";
import { getTwoLevelIndustryList } from "@/api/system/qqAdIndustry";
import { areaList } from '@vant/area-data';

export default {
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Form.name]: Form,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Form.name]: Form,
    [Calendar.name]: Calendar,
  },
  data() {
    return {
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        areaList
      },
      customer: {},
      listVisit: [],
      // 地区树选项
      areaOptions: [],
      // 行业树选项
      industryOptions: [],
      // 发票类型
      invoiceTypeOptions: [],
      // 发票状态
      invoiceStatusOptions: [],
      //证件类型
      ideTypeOptions: [],
      //角色关系
      roleRelationOptions: [],
      //亲密程度
      intimacyOptions: [],
      show: false,
      //添加联系人
      addContactShow: false,
      //生日
      showBirthdayCalendar: false,
      //证件类型
      showPopupPicker: false,
      active: 0,
      //跟进记录tab
      activeName: 'active_visit',
      form: {
        invoiceId: null,
        contractId: null,
        contractName: null,
        invoiceTitle: null,
        invoiceType: null,
        invoiceNum: null,
        custId: null,
        custName: null,
        taxNum: null,
        bankName: null,
        accountNum: null,
        postalCode: null,
        email: null,
        mobile: null,
        address: null,
        invoiceStatus: "0",
        userId: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null
      },
      // 表单校验
      rules: {
        custName: [
          { required: true, trigger: "blur" }
        ],
        custLevelId: [
          { required: true, trigger: "blur" }
        ],
        custSource: [
          { required: true, trigger: "blur" }
        ],
        custType: [
          { required: true, trigger: "blur" }
        ],
        industryCode: [
          { required: true, trigger: "blur" }
        ],
        areaId: [{ required: true, trigger: "blur" }],
        custStatus: [
          { required: true, trigger: "blur" }
        ]
      },
    }
  },
  mounted() {
    //发票类型
    this.getDicts("accinvoice_invoice_type").then(response => {
      this.invoiceTypeOptions = response.data; // string
    });
    //发票状态
    this.getDicts("accinvoice_invoice_status").then(response => {
      this.invoiceStatusOptions = response.data; // string
    });

    // 获取地区（省、市）
    getProvinceCityList().then(response => {
      this.areaOptions = this.handleTree(response.data, "areaId");
    });
    // 获取行业（前2级）
    getTwoLevelIndustryList().then(response => {
      this.industryOptions = this.handleTree(response.data, "systemIndustryId");
    });
    this.init()

  },
  methods: {
    async init() {
      //修改主体框架标题
      document.title = "FINA-发票卡片";
      const res = await getInvoice(this.$route.params.id)
      if (res.code === 200) {
        this.customer = res.data
      }
    },
    //发票类型字典翻译
    invoiceTypeFormat2(invoiceType) {
      return this.selectDictLabel(this.invoiceTypeOptions, invoiceType);
    },
    invoiceTypeFormat(row, column) {
      return this.selectDictLabel(this.invoiceTypeOptions, row.invoiceType);
    },
    //发票类型字典翻译
    invoiceStatusFormat2(invoiceStatus) {
      return this.selectDictLabel(this.invoiceStatusOptions, invoiceStatus);
    },
    invoiceStatusFormat(row, column) {
      return this.selectDictLabel(this.invoiceStatusOptions, row.invoiceStatus);
    },
    /** 删除按钮操作 */
    handleDelete(invoiceId) {

      Dialog.confirm({
        title: '警告',
        message: '是否确认删除【我的客户】编号为"' + invoiceId + '"的数据项?'
      }).then(
      function () {
        return delInvoice(invoiceId);
      }).then(() => {
        Toast.success('删除成功');
        this.$router.push({ path: '/scrm/custorder' });
      }).catch(() => {
      });
    },
    submitUpdate() {

      updateInvoice(this.form).then(response => {
        Toast.success('修改成功');
        this.show = false;
        this.init();
      });
    },
    addVisit() {
      this.visitFormReset();
      this.show = true;
    },
    showPicker(type) {
      this.picker.formKey = type
      if (type === 'custLevelId') {
        this.picker.columns = this.custLevelOptions.map(ele => ele.levelName)
      }
      if (type === 'custSource') {
        this.picker.columns = this.custSourceOptions.map(ele => ele.dictLabel)
      }
      if (type === 'custType') {
        this.picker.columns = this.custTypeOptions.map(ele => ele.dictLabel)
      }
      if (type === 'industryCode') {
        this.picker.columns = this.industryOptions.map(ele => this.industryNormalizer(ele))
      }
      if (type === 'areaId') {
        this.picker.columns = this.areaOptions.map(ele => this.areaNormalizer(ele))
      }
      if (type === 'ideType') {
        this.picker.columns = this.ideTypeOptions.map(ele => ele.dictLabel);
      }
      if (type === 'roleRelation') {
        this.picker.columns = this.roleRelationOptions.map(ele => ele.dictLabel)
      }
      if (type === 'intimacy') {
        this.picker.columns = this.intimacyOptions.map(ele => ele.dictLabel)
      }
      this.picker.visible = true
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === 'custLevelId') {
        this.form.custLevelId = this.custLevelOptions[index].custLevelId
        this.form.custLevelName = this.custLevelOptions[index].levelName
      }
      if (this.picker.formKey === 'custSource') {
        this.form.custSource = this.custSourceOptions[index].dictValue
        this.form.custSourceName = this.custSourceOptions[index].dictLabel
      }
      if (this.picker.formKey === 'custType') {
        this.form.custType = this.custTypeOptions[index].dictValue
        this.form.custTypeName = this.custTypeOptions[index].dictLabel
      }
      if (this.picker.formKey === 'industryCode') {

        if (value.length == 2) {
          if (value[1].length > 0) {
            this.form.industryName = value[0] + '/' + value[1]
            let obj = this.industryOptions.find(item => item.industryName === value[0])
            if (obj != null) {
              this.form.industryCode = obj.children.find(item => item.industryName === value[1]).systemIndustryId
            }
          }

        } else {
          this.form.industryName = value[0]
          let obj = this.industryOptions.find(item => item.industryName === value[0])
          if (obj != null) {
            this.form.industryCode = obj.systemIndustryId
          }
        }

      }
      if (this.picker.formKey === 'areaId') {
        if (value.length == 2) {
          if (value[1].length > 0) {
            let obj = this.areaOptions.find(item => item.areaName === value[0])
            if (obj != null) {
              this.form.areaId = obj.children.find(item => item.areaName === value[1]).areaId
            }
            this.form.areaName = value[0] + '/' + value[1]
          }

        } else {
          this.form.areaName = value[0]
          let obj = this.areaOptions.find(item => item.areaName === value[0])
          if (obj != null) {
            this.form.areaId = obj.areaId
          }
        }

      }
      if (this.picker.formKey === 'ideType') {
        this.contactForm.ideType = this.ideTypeOptions[index].dictValue
        this.contactForm.ideTypeName = this.ideTypeOptions[index].dictLabel
      }
      if (this.picker.formKey === 'roleRelation') {
        this.contactForm.roleRelation = this.roleRelationOptions[index].dictValue
        this.contactForm.roleRelationName = this.roleRelationOptions[index].dictLabel
      }
      if (this.picker.formKey === 'intimacy') {
        this.contactForm.intimacy = this.intimacyOptions[index].dictValue
        this.contactForm.intimacyName = this.intimacyOptions[index].dictLabel
      }
      this.picker.visible = false
    },
    areaConfirm(values) {
      this.form.areaId = values[values.length - 1].code
      this.form.areaName = values[values.length - 1].name
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false;
    },
    pickerChange() { },
    handleUpdate(invoiceId) {

      getInvoice(invoiceId).then(response => {
        this.form = response.data
        this.show = true
      })
    },
    /** 转换地区数据结构 */
    areaNormalizer(node) {
      let arr = []
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].areaId,
            text: node.children[i].areaName
          }
          arr.push(item)
        }
      }
      return {
        id: node.areaId,
        text: node.areaName,
        children: arr
      };
    },
    /** 转换行业数据结构 */
    industryNormalizer(node) {
      let arr = []
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].systemIndustryId,
            text: node.children[i].industryName
          }
          arr.push(item)
        }
      }
      return {
        id: node.systemIndustryId,
        text: node.industryName,
        children: arr
      };
    },
    formatDate(date) { // 时间格式化 2019-09-08
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + '-' + month + '-' + day
    },
    onConfirmBirthday(data) {
      this.contactForm.birthday = this.formatDate(data);
      this.showBirthdayCalendar = false;
    },
    reset() {
      this.form = {
        invoiceId: null,
        contractId: null,
        contractName: null,
        invoiceTitle: null,
        invoiceType: null,
        invoiceNum: null,
        custId: null,
        custName: null,
        taxNum: null,
        bankName: null,
        accountNum: null,
        postalCode: null,
        email: null,
        mobile: null,
        address: null,
        invoiceStatus: "0",
        userId: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null
      };
    }

  }
}
</script>

<style lang="less">
  .title{
    display: flex;
    align-items: center;
    padding-bottom: 10px;

    span{
      margin-left: 5px;
    }

    .icon {
      display: inline-block;
      width: 40px;
      height: 40px;
    }
  }
  .section {
    padding-top: 20px;
    font-size: 28px;
    color: #999;
  }
</style>
